import { FormControl, FormHelperText } from "@chakra-ui/react";
import Select from "react-select";
import { useState } from "react";

export default function CustomSelect2({
    options,
    isClearable = true,
    isSearchable = true,
    isLoading = false,
    width = "100%",
    name,
    label = "",
    className = "customScrollBar",
    customStyles,
    isMulti = false,
    minH,
    onChange,
    value, // 👈 parent controlled value
    ...props
}: any) {
    const defaultStyles = {
        control: (provided: any) => ({
            ...provided,
            "min-height": minH,
            "max-height": "58px",
            backgroundColor: "white",
            borderColor: "#38B2AC", // teal.400
            width: width,
            boxShadow: "none",
            "&:hover": {
                borderColor: "teal",
            },
            overflow: "auto",
        }),
        option: (provided: any, state: { isSelected: any }) => ({
            ...provided,
            backgroundColor: state.isSelected ? "teal" : "white",
            color: state.isSelected ? "white" : "black",
            "&:hover": {
                backgroundColor: "#38B2AC",
                color: "white",
            },
            cursor: "pointer",
        }),
        singleValue: (provided: any) => ({
            ...provided,
            color: "teal",
            fontWeight: "500",
        }),
        menuList: (provided: any) => ({
            ...provided,
            maxHeight: 260,
            overflowY: "auto",
            "&::-webkit-scrollbar": { width: "8px", height: "10px" },
            "&::-webkit-scrollbar-track": {
                boxShadow: "inset 0 0 5px grey",
                borderRadius: "10px",
            },
            "&::-webkit-scrollbar-thumb": {
                background: "#2C7A7B",
                borderRadius: "10px",
            },
        }),
        menu: (provided: any) => ({
            ...provided,
            position: "absolute",
            width: "100%",
            zIndex: 1,
        }),
    };

    const [isFocused, setIsFocused] = useState(false);

    return (
        <FormControl id="select" variant="floating">
            <Select
                placeholder={""}
                classNamePrefix="select"
                isClearable={isClearable}
                isSearchable={isSearchable}
                isLoading={isLoading}
                name={name}
                isMulti={isMulti}
                options={options}
                styles={defaultStyles}
                value={value || null} // 👈 use parent state
                onFocus={() => setIsFocused(true)}
                onBlur={() => setIsFocused(false)}
                onChange={(val: any) => {
                    if (onChange) onChange(val);
                }}
                {...props}
            />
            <FormHelperText
                style={{
                    position: "absolute",
                    zIndex: 2,
                    backgroundColor: "white",
                    left: "20px",
                    fontSize: "14px",
                    fontWeight: "500",
                    top: value || isFocused ? "-18px" : "30%",
                    transition: "top 0.3s",
                    transform: value || isFocused ? "none" : "translateY(-50%)",
                }}
            >
                {label}
            </FormHelperText>
        </FormControl>
    );
}
